/**
 * Status, feedback en metrics.
 *
 * Gegenereerd bij de Hugeicons-migratie; handmatig uitbreiden mag.
 * Voeg een icoon hier toe, nooit rechtstreeks `@hugeicons/*` in een component.
 */
import {
    ActivityIcon,
    Alert02Icon,
    AlertCircleIcon,
    AnalyticsDownIcon,
    AnalyticsUpIcon,
    Award01Icon,
    BanIcon,
    CancelCircleIcon,
    ChampionIcon,
    ChartColumnIcon,
    CheckmarkCircle02Icon,
    CircleIcon,
    Clock01Icon,
    DashboardSpeed02Icon,
    FavouriteIcon,
    HappyIcon,
    HealtcareIcon,
    HelpCircleIcon,
    Idea01Icon,
    InformationCircleIcon,
    Loading03Icon,
    PartyIcon,
    RecordIcon,
    Rocket01Icon,
    SparklesIcon,
    StarIcon,
    ThumbsDownIcon,
    ThumbsUpIcon,
    Tick02Icon,
} from "@hugeicons/core-free-icons";

import { createIcon } from "./create-icon";

export const Activity = createIcon(ActivityIcon, "Activity");
export const AlertCircle = createIcon(AlertCircleIcon, "AlertCircle");
export const AlertOctagon = createIcon(Alert02Icon, "AlertOctagon");
export const AlertTriangle = createIcon(Alert02Icon, "AlertTriangle");
export const Award = createIcon(Award01Icon, "Award");
export const Ban = createIcon(BanIcon, "Ban");
export const BarChart04 = createIcon(ChartColumnIcon, "BarChart04");
export const BarChart3 = createIcon(ChartColumnIcon, "BarChart3");
export const ChartNoAxesColumn = createIcon(ChartColumnIcon, "ChartNoAxesColumn");
export const Check = createIcon(Tick02Icon, "Check");
export const CheckCircle = createIcon(CheckmarkCircle02Icon, "CheckCircle");
export const CheckCircle2 = createIcon(CheckmarkCircle02Icon, "CheckCircle2");
export const Circle = createIcon(CircleIcon, "Circle");
export const CircleCheckBig = createIcon(CheckmarkCircle02Icon, "CircleCheckBig");
export const CircleDot = createIcon(RecordIcon, "CircleDot");
export const CircleSlash = createIcon(BanIcon, "CircleSlash");
export const Clock = createIcon(Clock01Icon, "Clock");
export const Clock3 = createIcon(Clock01Icon, "Clock3");
export const Gauge = createIcon(DashboardSpeed02Icon, "Gauge");
export const GaugeCircle = createIcon(DashboardSpeed02Icon, "GaugeCircle");
export const Heart = createIcon(FavouriteIcon, "Heart");
export const HeartPulse = createIcon(HealtcareIcon, "HeartPulse");
export const HelpCircle = createIcon(HelpCircleIcon, "HelpCircle");
export const Info = createIcon(InformationCircleIcon, "Info");
export const InfoCircle = createIcon(InformationCircleIcon, "InfoCircle");
export const Lightbulb = createIcon(Idea01Icon, "Lightbulb");
export const LineChart = createIcon(AnalyticsUpIcon, "LineChart");
export const Loader2 = createIcon(Loading03Icon, "Loader2");
export const PartyPopper = createIcon(PartyIcon, "PartyPopper");
export const Rocket = createIcon(Rocket01Icon, "Rocket");
export const Rocket02 = createIcon(Rocket01Icon, "Rocket02");
export const SmilePlus = createIcon(HappyIcon, "SmilePlus");
export const Sparkles = createIcon(SparklesIcon, "Sparkles");
export const Star01 = createIcon(StarIcon, "Star01");
export const Stars01 = createIcon(SparklesIcon, "Stars01");
export const ThumbsDown = createIcon(ThumbsDownIcon, "ThumbsDown");
export const ThumbsUp = createIcon(ThumbsUpIcon, "ThumbsUp");
export const TrendDown01 = createIcon(AnalyticsDownIcon, "TrendDown01");
export const TrendUp01 = createIcon(AnalyticsUpIcon, "TrendUp01");
export const TrendUp02 = createIcon(AnalyticsUpIcon, "TrendUp02");
export const TrendingUp = createIcon(AnalyticsUpIcon, "TrendingUp");
export const Trophy01 = createIcon(ChampionIcon, "Trophy01");
export const XCircle = createIcon(CancelCircleIcon, "XCircle");
